<template>
    <div class="agreement_box no-trans" v-loading="loading">
        <el-dialog :title="titles" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box" v-if="form.yuangao==1">
                <div class="form_box">
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                {{ titles2 }}
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.yuangao" placeholder="请选择">
                                    <el-option v-for="(item,index) in yuangao_list" :key="index" :label="item.title"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                国籍
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.country" placeholder="请选择">
                                    <el-option v-for="(item,index) in country_list" :key="index" :label="item.title"
                                        :value="item.title">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <span>*</span>
                                当事人姓名
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.name" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                性别
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.sex" placeholder="请选择">
                                    <el-option v-for="(item,index) in sex_list" :key="index" :label="item.title"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                证件类型
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.cert_type" placeholder="请选择">
                                    <el-option v-for="(item,index) in cert_type_list" :key="index" :label="item.title"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                证件号码
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.cert_num" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                出生日期
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-date-picker v-model="form.birthday" type="date" placeholder="选择日期">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                民族
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.native" placeholder="请选择">
                                    <el-option v-for="(item,indedx) in native_list" :key="indedx" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                政治面貌
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.zzmm" placeholder="请选择">
                                    <el-option v-for="(item,index) in zzmm_list" :key="index" :label="item.title"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                联系电话
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.phone" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                电子邮箱
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.email" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                邮政编码
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.zip_code" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="forms">
                        <div class="fomr_titles">
                            <!-- <span>*</span> -->
                            居住地址
                        </div>
                        <div class="fomr_input2">
                            <el-input v-model="form.address1" placeholder="请输入内容"></el-input>
                        </div>
                    </div>
                    <div class="forms">
                        <div class="fomr_titles">
                            <!-- <span>*</span> -->
                            户籍地址
                        </div>
                        <div class="fomr_input2">
                            <el-input v-model="form.address2" placeholder="请输入内容"></el-input>
                        </div>
                    </div>
                </div>
                <div class="btn_flex">
                    <div class="bnts1" @click="handle_end">确定</div>
                    <div class="bnts2" @click="handle_qx">取消</div>
                </div>
                


                
            </div>
            <div class="dialog_box" v-if="form.yuangao==2||form.yuangao==3">
                <div class="form_box">
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                {{ titles2 }}
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.yuangao" placeholder="请选择">
                                    <el-option v-for="(item,index) in yuangao_list" :key="index" :label="item.title"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                国家或地区
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.country" placeholder="请选择">
                                    <el-option v-for="(item,index) in country_list" :key="index" :label="item.title"
                                        :value="item.title">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <span>*</span>
                                单位名称
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.name" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                邮政编码
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.zip_code" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                证件种类
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.cert_type" placeholder="请选择">
                                    <el-option v-for="(item,index) in cert_type_list" :key="index" :label="item.title"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                证件号码
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.cert_num" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                法定代表人
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.legal" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                联系电话
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.phone" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                代表人证件种类
                            </div>
                            <div class="fomr_input1">
                                <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
                                <el-select v-model="form.legal_cert_type" placeholder="请选择">
                                    <el-option v-for="(item,index) in cert_type_list" :key="index" :label="item.title"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                代表人证件号码
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.legal_cert_num" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                职务
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.duties" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                电子邮箱
                            </div>
                            <div class="fomr_input1">
                                <el-input v-model="form.email" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="forms">
                        <div class="fomr_titles">
                            <!-- <span>*</span> -->
                            机构所在地址
                        </div>
                        <div class="fomr_input2">
                            <el-input v-model="form.address" placeholder="请输入内容"></el-input>
                        </div>
                    </div>

                </div>
                <div class="btn_flex">
                    <div class="bnts1" @click="handle_end2">确定</div>
                    <div class="bnts2" @click="handle_qx">取消</div>
                </div>
            </div>
        </el-dialog>

        
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            titles: '新增原告',
            titles2: '原告',
            dialogVisible: false,//原告
            form:{
                type:1,//1原告 2被告 3第三人
                yuangao:1,//原告 1自然人 2法人 3非法人组织
                name:'',//姓名 //公司名
                country:'',//国籍
                sex:'',//1男 2女 0未知
                cert_type:'',//证件类型 1身份证 2社会统一信用代码
                cert_num:'',//资格证号
                birthday:'',//生日
                native:'',//民族
                zzmm:'',//政治面貌 1群众 2党员
                phone:'',//电话
                zip_code:'',//邮编
                address:"",//机构地址
                address1:'',//居住地址
                address2:'',//户籍地址
                legal:'',//法人
                legal_cert_type:'',//法人证件种类 1身份证 2社会统一信用代码
                legal_cert_num:"",//法人证件号
                duties:"",//职务
                email:'',//邮箱
            },
            //原告被告身份
            yuangao_list:[
                {
                   title:'自然人' ,
                   value:1,
                },
                {
                   title:'法人' ,
                   value:2,
                },  {
                   title:'非法人组织' ,
                   value:3,
                }
            ],
            country_list:[],//国籍
            //性别
            sex_list:[
                {
                    title:'男',
                    value:1,
                },
                {
                    title:'女',
                    value:2,
                }
            ],
            cert_type_list:[
                {
                    title:'身份证 ',
                    value:1,
                },
                {
                    title:'社会统一信用代码',
                    value:2,
                }
            ],
            //名族
            native_list:[],
            zzmm_list:[
                {
                    title:'群众',
                    value:1,
                },
                {
                    title:'党员',
                    value:2,
                }
            ],
            bj_form:{},

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_country_list()
        this.get_native_list()
    },
    methods: {
    
        get_native_list(){
            this.loading=true
            this.$api("native", {
			}, "get").then((res) => {
                this.loading = false
                console.log('民族列表',res)
                if (res.code == 1) {
                    this.native_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_country_list(){
            this.loading=true
            this.$api("nation", {
			}, "get").then((res) => {
                this.loading = false
                console.log('国籍列表',res)
                if (res.code == 1) {
                    
                    for (const key in res.data) {
                        this.country_list.push({
                            title:res.data[key],
                            value:key,
                        })
                    }
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleClose() {
            this.dialogVisible = false
            this. form={
                type:1,//1原告 2被告 3第三人
                yuangao:1,//原告 1自然人 2法人 3非法人组织
                name:'',//姓名 //公司名
                country:'',//国籍
                sex:'',//1男 2女 0未知
                cert_type:'',//证件类型 1身份证 2社会统一信用代码
                cert_num:'',//资格证号
                birthday:'',//生日
                native:'',//民族
                zzmm:'',//政治面貌 1群众 2党员
                phone:'',//电话
                zip_code:'',//邮编
                address:"",//机构地址
                address1:'',//居住地址
                address2:'',//户籍地址
                legal:'',//法人
                legal_cert_type:'',//法人证件种类 1身份证 2社会统一信用代码
                legal_cert_num:"",//法人证件号
                duties:"",//职务
                email:'',//邮箱
            }
        },
        handle_end() {
            if(!this.form.name){
                alertErr('请输入当事人姓名')
                return
            }
            this.dialogVisible = false

            this.$emit('handle_add',this.form,this.bj_form)
    
          
        },
        handle_end2() {
            if(!this.form.name){
                alertErr('请输入单位名称')
                return
            }
            this.dialogVisible = false

            this.$emit('handle_add',this.form,this.bj_form)
        },
        handle_qx() {
            this.dialogVisible = false
            this. form={
                type:1,//1原告 2被告 3第三人
                yuangao:1,//原告 1自然人 2法人 3非法人组织
                name:'',//姓名 //公司名
                country:'',//国籍
                sex:'',//1男 2女 0未知
                cert_type:'',//证件类型 1身份证 2社会统一信用代码
                cert_num:'',//资格证号
                birthday:'',//生日
                native:'',//民族
                zzmm:'',//政治面貌 1群众 2党员
                phone:'',//电话
                zip_code:'',//邮编
                address:"",//机构地址
                address1:'',//居住地址
                address2:'',//户籍地址
                legal:'',//法人
                legal_cert_type:'',//法人证件种类 1身份证 2社会统一信用代码
                legal_cert_num:"",//法人证件号
                duties:"",//职务
                email:'',//邮箱
            }
          
        },
        handle_open(i) {
            this.bj_form={}
            this.form={
                type:1,//1原告 2被告 3第三人
                yuangao:1,//原告 1自然人 2法人 3非法人组织
                name:'',//姓名 //公司名
                country:'',//国籍
                sex:'',//1男 2女 0未知
                cert_type:'',//证件类型 1身份证 2社会统一信用代码
                cert_num:'',//资格证号
                birthday:'',//生日
                native:'',//民族
                zzmm:'',//政治面貌 1群众 2党员
                phone:'',//电话
                zip_code:'',//邮编
                address:"",//机构地址
                address1:'',//居住地址
                address2:'',//户籍地址
                legal:'',//法人
                legal_cert_type:'',//法人证件种类 1身份证 2社会统一信用代码
                legal_cert_num:"",//法人证件号
                duties:"",//职务
                email:'',//邮箱
            }
            if (i == 1) {
                this.titles = '新增原告'
                this.titles2 = '原告'
                this.form.type=1
                this.dialogVisible = true
            }
            if (i == 2) {
                this.titles = '新增被告'
                this.titles2 = '被告'
                this.form.type=2
                this.dialogVisible = true

            }
            if (i == 3) {
                this.titles = '新增第三人'
                this.titles2 = '第三人'
                this.form.type=3
                this.dialogVisible = true

            }
        },
        handle_open_bj(item,index,form_text,i){
            if (i == 1) {
                this.titles = '新增原告'
                this.titles2 = '原告'
                this.form.type=1
                this.dialogVisible = true
            }
            if (i == 2) {
                this.titles = '新增被告'
                this.titles2 = '被告'
                this.form.type=2
                this.dialogVisible = true

            }
            if (i == 3) {
                this.titles = '新增第三人'
                this.titles2 = '第三人'
                this.form.type=3
                this.dialogVisible = true

            }
            this.form=item
            this.bj_form={
                index:index,
                form_text:form_text,
            }
        }



    },

}
</script>
<style scoped lang="less">
.agreement_box {
    /deep/.el-dialog__wrapper {
        .el-dialog {
            width: 960px;

            .el-dialog__header {
                background: #F7F7F7;
            }

            .el-dialog__body {
                .dialog_box {
                    .form_box {
                        padding: 20px 20px;

                        .form_flex {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        }

                        .forms {
                            display: flex;
                            align-items: center;
                            margin-bottom: 24px;

                            .fomr_titles {
                                width: 120px;
                                flex-shrink: 0;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                display: flex;
                                align-items: center;
                                justify-content: flex-end;
                                padding-right: 15px;

                                span {
                                    color: #FD4C5C;
                                    margin-right: 5px;
                                }
                            }

                            .fomr_input1 {
                                width: 320px;

                                .el-select {
                                    width: 320px;
                                }

                                .el-date-editor {
                                    width: 320px;
                                }
                            }

                            .fomr_input2 {
                                width: 817px;
                            }
                        }

                    }

                    .btn_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .bnts1 {
                            width: 104px;
                            height: 40px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            line-height: 40px;
                            text-align: center;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;

                        }

                        .bnts2 {
                            width: 104px;
                            height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .agreement_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box {
        padding: 16px 16px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        flex-direction: column;
        align-items: stretch;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_titles {
        width: 120px;
        font-size: 14px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-right: 15px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_titles span {
        margin-right: 5px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_input1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_input1 .el-select {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_input1 .el-date-editor {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_input2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex .bnts1 {
        width: 104px;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        line-height: 40px;
        font-size: 14px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex .bnts2 {
        width: 104px;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        line-height: 40px;
        font-size: 14px;
        margin-left: 16px;
    }
}
</style>
